import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit,
    startAfter,
    endBefore
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import Promise from "bluebird";
import _ from "lodash";

export {
    addImages,
    updateImages,
    addSingleImage,
    updateSingleImage,
    deleteSingleImage,
    getSingleImage,
    searchImages,
    prepareImagesList
}

const collectionName = 'images';
const collectionReference = collection(fireStoreDB, collectionName);

const addImages = (images) => {
    return Promise.map(images, async image => {
        await addSingleImage(image);
    });
}

const updateImages = (images) => {
    return Promise.map(images, async image => {
        await updateSingleImage(image);
    });
}

const addSingleImage = (image) => {
    prepareImageBeforeAddOrUpdate(image);

    image.createdAt = new Date();
    image.updatedAt = image.createdAt;
    return addDoc(collectionReference, image);
}

const updateSingleImage = (image) => {
    image.updatedAt = new Date();
    const documentReference = doc(fireStoreDB, collectionName, image.id);
    return setDoc(documentReference, image);
}

const deleteSingleImage = (image) => {
    const documentReference = doc(fireStoreDB, collectionName, image.id);
    return deleteDoc(documentReference);
}

const getSingleImage = (imageId) => {
    const documentReference = doc(fireStoreDB, collectionName, imageId);
    return getDoc(documentReference);
}

const searchImages = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    if (_.isEmpty(searchCriteriaList)) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }

    _.forEach(searchCriteriaList, async searchCriteria => {
        if (searchCriteria.field === 'endBefore') {
            searchQuery = query(searchQuery, endBefore(searchCriteria.value));
        } else if (searchCriteria.field === 'startAfter') {
            searchQuery = query(searchQuery, startAfter(searchCriteria.value));
        } else {
            searchQuery = query(searchQuery,
                where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
        }
    });

    searchQuery = query(searchQuery, limit(40));

    const imageResult = await getDocs(searchQuery);
    return prepareImagesList(imageResult);
}

const prepareImagesList = (imageResult) => {
    const imagesList = [];

    _.forEach(imageResult.docs, imageDoc => {
        imagesList.push({
            ...imageDoc.data(),
            id: imageDoc.id
        });
    });

    return imagesList;
}

const prepareImageBeforeAddOrUpdate = (image) => {
    _.forEach(image, (value, key) => {
        if (!value) {
            image[key] = ''
        }
    });
}

